// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"fac8dd68","777":"eb114a80","844":"b8df8a2b"}[chunkId] + ".chunk.js";
};